import React from 'react';
import { ArrowRight, CloudLightning as Lightning, ShieldCheck, Clock, Truck as TruckFast } from 'lucide-react';
import { Link } from 'react-router-dom';
import ContactForm from '../forms/ContactForm';

const Hero: React.FC = () => {
  return (
    <section className="relative overflow-hidden">
      {/* Video Background */}
      <div className="absolute inset-0 z-0 min-h-[70vh]">
        <video
          autoPlay
          muted
          loop
          playsInline
          className="w-full h-full object-cover"
        >
          <source src="/videos/0510(1).mp4" type="video/mp4" />
        </video>
        {/* Overlay */}
        <div className="absolute inset-0 bg-primary-900/40"></div>
      </div>

      {/* Content */}
      <div className="container-custom relative z-10 pt-16 pb-16 md:pb-24 lg:pb-32">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-8 items-center">
          {/* Left column: Text content */}
          <div>
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-6 leading-tight text-white">
              Трансформаторы <span className="lg:hidden"><br /></span>
              ТСЛ ТСЗ и ТМГ от Проминнова – надежность и экономия для вашего проекта
            </h1>
            
            <p className="text-xl md:text-2xl text-primary-100 mb-8">
              Экономия до 10%, производство за 50-75 дней, быстрая доставка по РФ
            </p>
            
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-8">
              <div className="flex items-start">
                <div className="bg-primary-700 bg-opacity-50 rounded-lg p-2 mr-3">
                  <ShieldCheck className="w-5 h-5 text-primary-300" />
                </div>
                <div>
                  <p className="font-medium text-white">Пожаробезопасность</p>
                  <p className="text-sm text-primary-200">Сухие трансформаторы</p>
                </div>
              </div>
              
              <div className="flex items-start">
                <div className="bg-primary-700 bg-opacity-50 rounded-lg p-2 mr-3">
                  <Lightning className="w-5 h-5 text-primary-300" />
                </div>
                <div>
                  <p className="font-medium text-white">Экономия 5-10%</p>
                  <p className="text-sm text-primary-200">В закупке и на электроэнергии</p>
                </div>
              </div>
              
              <div className="flex items-start">
                <div className="bg-primary-700 bg-opacity-50 rounded-lg p-2 mr-3">
                  <Clock className="w-5 h-5 text-primary-300" />
                </div>
                <div>
                  <p className="font-medium text-white">50-75 дней</p>
                  <p className="text-sm text-primary-200">Срок производства</p>
                </div>
              </div>
              
              <div className="flex items-start">
                <div className="bg-primary-700 bg-opacity-50 rounded-lg p-2 mr-3">
                  <TruckFast className="w-5 h-5 text-primary-300" />
                </div>
                <div>
                  <p className="font-medium text-white">Доставка в любую точку РФ</p>
                  <p className="text-sm text-primary-200">Авто 2-15дней, ЖД и Спецтранспортом</p>
                </div>
              </div>
            </div>
            
            <div className="flex flex-wrap items-center gap-4">
              <Link to="/catalog" className="btn-primary inline-flex items-center group">
                Каталог продукции
                <ArrowRight className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform" />
              </Link>
              
              <Link to="/projects" className="text-white hover:text-primary-200 font-medium inline-flex items-center transition-colors">
                Наши проекты
                <ArrowRight className="ml-1 w-4 h-4" />
              </Link>
            </div>
          </div>
          
          {/* Right column: Form */}
          <div>
            <div className="bg-white text-gray-900 rounded-xl shadow-xl overflow-hidden">
              <div className="p-6">
                <h3 className="text-xl font-semibold mb-2">Оставьте заявку</h3>
                <p className="text-gray-600 mb-6">
                  Заполните форму, и наш менеджер свяжется с вами в течение 2 часов (в рабочее время).
                </p>
                <ContactForm />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;